export default __webpack_public_path__ + "static/media/D2019_11_28_San_Juan.9596c3b1.jpg";